var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Crear personas desde deudas")]),_c('v-card-subtitle',[_vm._v("Este job crear personas a partir de las deudas cargadas")]),_c('v-card-text',{staticClass:"text-center"},[_c('v-btn',{attrs:{"color":"primary OnPrimary--text"},on:{"click":_vm.generar}},[_vm._v("Generar")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }